var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2641 1.65782C12.3969 1.53126 13.0673 1.53126 14.2844 1.65782C16.439 1.97672 18.4363 2.97264 19.9876 4.50157C18.9393 5.49241 17.9049 6.49771 16.8844 7.51719C14.9303 5.86094 12.749 5.47865 10.3407 6.37032C8.57403 7.18282 7.34382 8.49949 6.65007 10.3203C5.51639 9.4763 4.39747 8.61263 3.29382 7.72969C3.21712 7.68932 3.12952 7.67454 3.04382 7.68751C4.79695 4.3073 7.53653 2.29688 11.2626 1.65626",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04065 7.68751C3.12919 7.67397 3.21305 7.68803 3.29222 7.7297C4.39586 8.61263 5.51478 9.47631 6.64847 10.3203C6.47007 11.0298 6.35761 11.7542 6.31253 12.4844C6.35107 13.1906 6.46305 13.8839 6.64847 14.5641L3.12503 17.3688C1.59065 14.1625 1.56253 10.9354 3.04065 7.68751Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8204 20.7656C18.7233 19.7981 17.5747 18.8905 16.3797 18.0469C17.5777 17.2011 18.3047 16.0406 18.561 14.5656H12.6907V10.4891C16.0761 10.4609 19.4599 10.4896 22.8422 10.575C23.4839 14.0594 22.7428 17.2011 20.6188 20C20.3662 20.2685 20.0987 20.524 19.8204 20.7656Z",
    fill: "#448AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64844 14.5656C7.92969 17.75 10.2786 19.2365 13.6953 19.025C14.6544 18.914 15.574 18.5789 16.3797 18.0469C17.5755 18.8927 18.7224 19.799 19.8203 20.7656C18.0807 22.3288 15.8627 23.2564 13.5281 23.3969C12.9977 23.4393 12.4648 23.4393 11.9344 23.3969C7.95729 22.9281 5.02083 20.9188 3.125 17.3688L6.64844 14.5656Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.be1f8076d2f4402a2f930eca0e6ed778.svg";
export { ForwardRef as ReactComponent };